import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const QuotationNo = (props) => {
  return (
    <FormGroup controlId="quotationNo">
      <Col componentClass={ControlLabel} sm={5}>
        Quotation Number *
      </Col>
    <Col sm={7}>
        <FormControl type="text" value={props.quotationNo}
          onChange={props.handleChangeQuotationNo} disabled />
    </Col>
    </FormGroup>
  )
}

QuotationNo.propTypes = {
  quotationNo: PropTypes.string,
  handleChangeQuotationNo: PropTypes.func
};

export default QuotationNo;



// WEBPACK FOOTER //
// ./src/app/components/quotationNo/QuotationNo.js